import { render, staticRenderFns } from "./mutasideposito.vue?vue&type=template&id=13f3a794&scoped=true&"
import script from "./mutasideposito.vue?vue&type=script&lang=js&"
export * from "./mutasideposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f3a794",
  null
  
)

export default component.exports